<button [style.min-height.px]="minHeight" 
        [style.height.px]="height" 
        [style.min-width.px]="minWidth" 
        [style.width.px]="width"
        [style.background-color]="currentBgColor"
        [style.color]="currentTextColor"
        [style.border]="currentBorder"
        [style.border-radius.px]="radius"
        [style.padding]="padding"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        class="flex gap-10 content-center align-items-center pointer"
        [ngClass]="{'flex-row': iconPosition === 'left', 'flex-reverse-row': iconPosition === 'right'}">
  <img *ngIf="currentIcon.length > 0" width="40px" [src]="currentIcon" [alt]="iconAlt"><p>{{buttonText}}</p>
</button>